import { render, staticRenderFns } from "./MyPeopleInformation.vue?vue&type=template&id=eb6c7f40&scoped=true"
import script from "./MyPeopleInformation.vue?vue&type=script&lang=js"
export * from "./MyPeopleInformation.vue?vue&type=script&lang=js"
import style0 from "./MyPeopleInformation.vue?vue&type=style&index=0&id=eb6c7f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6c7f40",
  null
  
)

export default component.exports